/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { GetFreightModesResponseType } from "api/response";
import { getFreightModes } from "api/services/common";
import { commonQueryKeys } from "./commonQueryKeys";

type GetFreightModeOptions = {
  params?: Record<string, any>;
  includeCustom?: boolean;
  options?: UseQueryOptions<GetFreightModesResponseType>;
};

export function useGetCommonFreightModes(data: GetFreightModeOptions) {
  const { params = {}, includeCustom, options } = data;
  return useQuery({
    queryKey: commonQueryKeys.freightModes({ params, includeCustom }),
    queryFn: () => getFreightModes(params, includeCustom).then((res) => res.data),
    ...options,
  });
}
